import { render, staticRenderFns } from "./ComponentBindingList.vue?vue&type=template&id=58cace54&"
import script from "./ComponentBindingList.vue?vue&type=script&lang=js&"
export * from "./ComponentBindingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports